import { Box, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import React from 'react'

import { getLoginPromoConfig } from '@/src/constants/domain'

interface StandardLoginFlowBenefitsProps {
    // No props needed currently
}

export const StandardLoginFlowBenefits: React.FC<StandardLoginFlowBenefitsProps> = () => {
    const t = useTranslations('otpModal')
    const { discount, code } = getLoginPromoConfig()

    return (
        <>
            {/* Standard Flow: Sign Up & Save Section */}
            <Box>
                <Typography variant="h5" sx={{ fontWeight: 600, mb: 0.75, fontSize: 18 }}>
                    {t('signUpAndSave.title')}
                </Typography>
                <Typography variant="body2" sx={{ mb: 0, fontSize: 12, opacity: 0.9, lineHeight: 1.5 }}>
                    {t('signUpAndSave.description', { discount, code })}
                </Typography>
            </Box>

            {/* Standard Flow: Log In for More Perks Section */}
            <Box>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.75, fontSize: 15 }}>
                    {t('logInForMorePerks.title')}
                </Typography>
                <Typography variant="body2" sx={{ mb: 1.25, fontSize: 12, opacity: 0.9 }}>
                    {t('logInForMorePerks.subtitle')}
                </Typography>
                <Box component="ul" sx={{ pl: 0, m: 0, listStyle: 'none' }}>
                    {[
                        t('logInForMorePerks.benefits.0'),
                        t('logInForMorePerks.benefits.1'),
                        t('logInForMorePerks.benefits.2'),
                        t('logInForMorePerks.benefits.3')
                    ].map((benefit: string, index: number) => (
                        <Box
                            component="li"
                            key={index}
                            sx={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                mb: 0.875,
                                '&:last-child': { mb: 0 }
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: 12,
                                    fontWeight: 400,
                                    color: 'common.white',
                                    lineHeight: 1.5,
                                    pl: 1.5,
                                    position: 'relative',
                                    '&::before': {
                                        content: '"•"',
                                        position: 'absolute',
                                        left: 0,
                                        fontSize: 14,
                                        lineHeight: 1.5
                                    }
                                }}
                            >
                                {benefit}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Box>
        </>
    )
}
